import React from 'react';
import { IIconProps } from './utils';

export const CloudInProgress = ({
  fill = 'currentColor', height = 30, width = 30, stroke, ...rest
}: IIconProps) => (
  <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M3.74219 13.5C2.49955 13.5 1.49219 12.4926 1.49219 11.25C1.49219 10.0705 2.39981 9.10295 3.55474 9.0077C3.65795 8.99919 3.74179 8.9158 3.74603 8.81233C3.84441 6.41408 5.81977 4.5 8.24219 4.5C10.1916 4.5 11.8516 5.73963 12.4767 7.47362C12.5123 7.57245 12.6195 7.62698 12.721 7.60005C12.9671 7.53478 13.2256 7.5 13.4922 7.5C15.149 7.5 16.4922 8.84315 16.4922 10.5C16.4922 12.1569 15.149 13.5 13.4922 13.5H3.74219Z" stroke={stroke || fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.6875 11L11.6892 11.0017" stroke={stroke || fill} strokeWidth="2" strokeLinecap="round"/>
    <path d="M5.68931 11H5.6875" stroke={stroke || fill} strokeWidth="2" strokeLinecap="round"/>
    <path d="M8.6875 11V11.0018" stroke={stroke || fill} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
